import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useGuestCartAccsService } from '@/services/guest_cart_accs.service.js'
// import { getDomain } from '@/services/util.service'

//  Pinia Store for Guest Cart
export const useGuestCartAccsStore = defineStore('guestCartAccs', () => {
    const { isLoading, error, addDesignerProject } = useBaseCartAccs()

    //   Importing APIs from Guest Cart Service
    const {
        createGuestCart,
        //   fetchGuestCart,
        addToGuestCart,
        //   fetchCartTotal, // Get total price, qty etc.
    } = useGuestCartAccsService()

    const runtimeConfig = useRuntimeConfig() as {
        public?: {
            guestQuoteId?: string
            designerBaseUrl?: string
            storefrontUrl?: string
        }
    }
    /** Magento guest-cart cookie name; from `NUXT_PUBLIC_GUEST_QUOTE_ID` (Bitwarden per env). */
    const guestQuoteCookieName = runtimeConfig.public?.guestQuoteId as string

    const guestQuoteCookie = useAppCookie<string>(guestQuoteCookieName, { maxAge: 60 * 60 * 168 })

    const quoteId = ref(guestQuoteCookie.get() || undefined) // Guest cart ID

    const ensureGuestCartExists = async (): Promise<string> => {
        if (!quoteId.value) {
            const { data, error } = await createGuestCart()

            if (error?.value) {
                throw error.value
            }

            // Validate that we have a valid value from Magento before setting cookie
            if (!data?.value || typeof data.value !== 'string' || data.value.trim() === '') {
                throw new Error('Invalid cart ID returned from Magento')
            }

            // Cookie domain comes from runtimeConfig.public.cartDomain (generateEnv → NUXT_PUBLIC_CART_DOMAIN).

            // Validate that cookie domain matches storefront domain
            // const designerBaseUrl = runtimeConfig.public?.designerBaseUrl
            // const storefrontUrl = runtimeConfig.public?.storefrontUrl

            // if (designerBaseUrl && storefrontUrl) {
            //     const cookieDomain = getDomain(designerBaseUrl)
            //     const storefrontDomain = getDomain(storefrontUrl)

            //     if (cookieDomain !== storefrontDomain) {
            //         throw new Error(
            //             `Cookie domain (${cookieDomain}) does not match storefront domain (${storefrontDomain})`
            //         )
            //     }
            // }
            // Wrap cookie setting in try/catch as a failsafe
            try {
                guestQuoteCookie.setIfExists(data.value)
                quoteId.value = data.value
            } catch (cookieError) {
                // If cookie setting fails, throw error - this is a critical failure
                // The cart won't work without the cookie being set
                const errorObj =
                    cookieError instanceof Error ? cookieError : new Error(String(cookieError))
                throw errorObj
            }
        }

        return quoteId.value as string
    }

    const addDesignerProjectToCart = async () => {
        await ensureGuestCartExists()
        await addDesignerProject(addToGuestCart) // inject guest service
    }
    const clearGuestCookie = (): void => {
        quoteId.value = undefined
        guestQuoteCookie.remove()
    }

    // Expose State & Actions
    return {
        quoteId,
        isLoading,
        error,
        clearGuestCookie,
        addDesignerProjectToCart,
    }
})
